import { clearUrl } from '@elfsight/widget-utils';
import type {
  SpecificPagesType,
  VisibilityOnPagesSettingsType
} from '../types';

export const isVisibleOnPage = (
  settings: VisibilityOnPagesSettingsType | null,
  _debugURL?: string
) => {
  if (!settings) {
    return true;
  }

  const {
    visibilityOnPagesDisplayMode: displayMode,
    visibilityOnPagesDisplayPages: displayPages,
    visibilityOnPagesHideMode: hideMode,
    visibilityOnPagesHidePages: hidePages
  } = settings;

  let urlClass: URL;
  try {
    urlClass = new URL(_debugURL || document.location.href);
  } catch {
    return true;
  }
  const fullPath = clearUrl(`${urlClass.host}${urlClass.pathname}`);

  // Регулярка для homepage, с учетом формата test.com/index.html
  const HOMEPAGE_REGEXP = `${clearUrl(
    urlClass.host
  )}(\\/)?(index\\.(.*))?($|\\?)`;

  const displayRegexps = {
    allPages: '.*',
    homepage: HOMEPAGE_REGEXP,
    specificPages: formatPagesToRegExp(displayPages, '.*')
  };

  const hideRegexps = {
    none: '(?!.*)',
    homepage: HOMEPAGE_REGEXP,
    specificPages: formatPagesToRegExp(hidePages, '(?!.*)')
  };

  const displayRegExp = new RegExp(displayRegexps[displayMode]);
  const isVisible = displayRegExp.test(fullPath);

  const hideRegExp = new RegExp(hideRegexps[hideMode]);
  const isHidden = hideRegExp.test(fullPath);

  return isVisible && !isHidden;
};

// Бежим по списку specific pages и превращаем его в одну регулярку
const formatPagesToRegExp = (
  pages: SpecificPagesType = [],
  defaultValue = ''
) => {
  const filterPages = pages
    .filter((page) => !!page.link)
    .map((page) => `(${formatLinkToRegExp(clearUrl(page.link))})`)
    .join('|');

  return filterPages || defaultValue;
};

// Делаем из ссылки регулярное выражение
// Экранируем url и добавляем поддержку /* c помощью добавлена (.*) в регулярку
const formatLinkToRegExp = (str: string) => {
  return (
    str.replace(/\/\*|[/.*+?^${}()|[\]\\]/g, (match) => {
      if (match === '/*' || match === '*') return '(.*)';

      return `\\${match}`;
    }) + '$'
  );
};
